export const getCardFieldFiat = (obj: Record<string, any>, key: string) => {
  if (!obj?.[key]) return '';

  const value = obj[key].toString().trim();
  const last4 = value.slice(-4);
  return last4 ? `${key.toUpperCase()}: ( ****${last4} )` : '';
};

export const getCardFieldCrypt = (obj: any) => {
  const { adress, name } = obj;
  if (!adress?.card) return name || '';

  const cardStr = adress.card.toString().trim();
  const last4 = cardStr.slice(-4);
  return `${name} ( *** ${last4} )`;
};
